import * as React from 'react';
export const starSvg = React.forwardRef(function starSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#CD0E41',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M24.94 6.449 25.9 3.5l.962 2.949h3.111L27.457 8.27l.96 3.068-2.516-1.941-2.517 1.941.961-3.067-2.517-1.823h3.111Zm-4.936.025c-1.775.003-5.28.134-9.534.941C3.73 8.695 2 11.012 2 11.012h6.224l.104-.177C8.875 9.9 9.441 8.93 12.385 7.93c3.13-1.064 8.876-1.174 8.876-1.174v-.257s-.45-.025-1.257-.024ZM5.517 11.985s.05-.002.142-.002c.275.002.917.03 1.663.222h7.954s-.165.606-.147 1.432c0 0-1.16-.386-2.799-.092v7.745h-2.228v-7.782s-.976-.147-2.615.018c0 0-.847-.568-1.823-.568s-1.676.293-1.676 1.156c0 .76.974 1.164 1.784 1.5l.316.133c.847.367 2.301 1.046 2.301 2.753 0 1.706-1.565 2.991-3.811 2.991-1.823 0-2.578-.587-2.578-.587s.313-.88.46-1.707l.424-.055s.166 1.377 1.73 1.377c1.566 0 1.787-.863 1.787-1.395s-.792-1.101-2.044-1.56c-1.252-.459-2.247-1.248-2.247-2.79 0-1.54 1.345-2.789 3.407-2.789Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M26.65 12.205h.014c.263-.003 2.367.038 2.367 1.982 0 0 .221 2.147-2.099 2.551 0 0 1.625 2.716 3.068 4.552h-2.872l-2.46-4.13v4.13h-5.035l-1.017-2.735h-2.963l-1.212 2.735h-1.584l4.272-9.085h1.639l3.462 8.758v-8.758h4.419Zm.024 2.24c0-1.188-1.093-1.36-1.709-1.364a2.98 2.98 0 0 0-.408.024v3.083c1.38 0 2.117-.22 2.117-1.744Zm-8.433 3.1-.976-2.624-1.164 2.625h2.14Z',
      fill: '#fff',
    }),
  );
});
starSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var star = {
  category: 'brand',
  colorable: false,
  name: 'star',
  svg: starSvg,
};
